import React, { useState, useContext } from "react";
import Header from '../../components/Header';
import TableComponent from '../../components/TableComponent';
import MultiSelectComponent from '../../components/MultiSelectComponent';
import DateRangePickerComponent from '../../components/DateRangePickerComponent';
import TextComponent from '../../components/TextComponent';
import Dashboard from '../../components/Dashboard';
import PageHeaderComponent from '../../components/PageHeaderComponent';
import { CubeJSContext } from '../../context/CubeJSProvider';
import OmnitechQueries from '../../queries/OmnitechQueries'
import { useTranslation } from 'react-i18next';
import { useCubeQuery } from '@cubejs-client/react';
import { setHours, setMinutes, setSeconds, setMilliseconds, format } from 'date-fns'

const applyFilter = (query, storeFilter) => {
  let storeCodeFilterObj = {
    member: "SkuSalesDetailCHE.shipFromStoreCode",
    operator: "equals",
    values: storeFilter
  }

  query = {
    ...query,
    filters: (query.filters || []).concat(storeCodeFilterObj)
  }

  return query
}

const SKUSalesDetailsCHEHistQuery = (storeFilter, startDateFilter, endDateFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null && endDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  else if(startDateFilter == null){
    startDateFilter = setHours(endDateFilter, 0)
    startDateFilter = setMinutes(startDateFilter, 0)
    startDateFilter = setSeconds(startDateFilter, 0)
    startDateFilter = setMilliseconds(startDateFilter, 0)
  }
  else if (endDateFilter == null){
    endDateFilter = setHours(startDateFilter, 23)
    endDateFilter = setMinutes(endDateFilter, 59)
    endDateFilter = setSeconds(endDateFilter, 59)
    endDateFilter = setMilliseconds(endDateFilter, 999)
  }
  let item = {
    name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.name'),
    tableHeaders: {
      "SkuSalesDetailCHE.skuCode": { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.skuCode'), type: 'string'},
      "SkuSalesDetailCHE.upcCode": { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.upcCode'), type: 'string'},
      "SkuSalesDetailCHE.internalUseTitle": { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.skuInternalUseTitle'), type: 'string'},
      "SkuSalesDetailCHE.productCode": { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.productCode'), type: 'string'},
      "SkuSalesDetailCHE.productTitleEnHk": { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.productTitleEnHk'), type: 'string'},
      "SkuSalesDetailCHE.productTitleZhHk":  { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.productTitleZhHk'), type: "string" },
      "SkuSalesDetailCHE.productStatus": { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.productStatus'), type: 'string'},
      "SkuSalesDetailCHE.skuCost": { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.skuCost'), type: 'number'},
      "SkuSalesDetailCHE.currentPrice": { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.currentPrice'), type: 'number'},
      "SkuSalesDetailCHE.skuMeasurementUnit": { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.skuMeasurementUnit'), type: 'number'},
      "SkuSalesDetailCHE.rsmrCode":  { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.rsmrCode'), type: "string" },
      "SkuSalesDetailCHE.rsmCode":  { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.rsmCode'), type: "string" },
      "SkuSalesDetailCHE.propertyAc":  { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.propertyAc'), type: "string" },
      "SkuSalesDetailCHE.commerceChannelCodes":  { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.commerceChannelCodes'), type: "string" },
      "SkuSalesDetailCHE.subcatCategoryCode":  { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.subcatCategoryCode'), type: "string" },
      "SkuSalesDetailCHE.mainCategoryCode":  { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.mainCategoryCode'), type: "string" },
      "SkuSalesDetailCHE.lineTotal": { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.lineTotal'), type: 'number'},
      "SkuSalesDetailCHE.quantity": { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.quantity'), type: 'number'},
      "SkuSalesDetailCHE.skuMeasure": { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.skuMeasure'), type: 'number'},
      "SkuSalesDetailCHE.skuMeasurementCode": { name: t('page.che.SKUSalesCHEDetailsHistPage.SKUSalesDetails.tableHeader.skuMeasurementCode'), type: 'string'},
    },
    grid: {xs: 12},
    export: { allowExport: true, filename: 'sku_sales_details_export_' + format(startDateFilter, 'yyyyMMddHHmmss') +
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.mvOrderTransactions.SKUSalesDetailsCHE.query,
    "timeDimensions": [
      {
        "dimension": "SkuSalesDetailCHE.ordersCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter)
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const SKUSalesDetailsCHEHistPage = () => {
  const { t } = useTranslation();
   const context = useContext(CubeJSContext);
  let storeCodeSelect = []
  if(context.storeCodes)
    storeCodeSelect = context.storeCodes
  const [ storeFilter, setStoreFilter ] = useState([]);
  let filterStartDate = new Date()
  filterStartDate.setHours(0,0,0,0);
  let filterEndDate = new Date()
  filterEndDate.setHours(23,59,59,999);
  const [dateRangeFilter, setDateRangeFilter] = useState([filterStartDate, filterEndDate])
  const [startDateFilter, endDateFilter] = dateRangeFilter
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page1, setPage1] = useState(0);

  const [ refresh1, setRefresh1 ] = useState(false);

  const query1  = SKUSalesDetailsCHEHistQuery(storeFilter, startDateFilter, endDateFilter, refresh1, setRefresh1)

  const refresh = () => {
    setRefresh1(true)
    setPage1(0)
  }

  return ([
    <Header />,
    <PageHeaderComponent onClickFunc={refresh} refreshlabel={t('component.refresh')} headerTitle={t('component.header.menu.skuSalesDetailsCHEHist')} />,
    <Dashboard>
      <MultiSelectComponent id={"store_code_filter"} state={storeFilter} pageChangerArr={[setPage1]}
          stateChanger={setStoreFilter} textLabel={t('page.che.SKUSalesCHEDetailsHistPage.filter.store.name')} selectArray={storeCodeSelect}/>
      <DateRangePickerComponent state={dateRangeFilter} stateChanger={setDateRangeFilter} pageChangerArr={[setPage1]}
        startDateLabel={t('page.che.SKUSalesCHEDetailsHistPage.filter.orderCompletedAt.startDate')} 
        toLabel={t('page.che.SKUSalesCHEDetailsHistPage.filter.orderCompletedAt.to')} 
        endDateLabel={t('page.che.SKUSalesCHEDetailsHistPage.filter.orderCompletedAt.endDate')}/>
    </Dashboard>
    ,
    <Dashboard>
      <TextComponent title={t('component.text.historical')} xs={12} />
      <TableComponent item={query1.item} result={query1.result} rowsPerPage={rowsPerPage} 
        setRowsPerPage={setRowsPerPage} page={page1} setPage={setPage1}/>
    </Dashboard>
  ]) 
};

export default SKUSalesDetailsCHEHistPage;